import React, { memo } from 'react'
import { Helmet } from 'react-helmet-async'

import { buildPageTitle } from '../../../util/app/app.helpers'
import PageHeading from '../text/PageHeading'

const PageTitle = ({ customTitle, title, desc, noHeading = false }) => {
  return (
    <>
      <Helmet>
        <title>{buildPageTitle(customTitle || title)}</title>
      </Helmet>
      {!noHeading && <PageHeading title={title} desc={desc} />}
    </>
  )
}

export default memo(PageTitle)
